
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EquipmentInventory } from "./EquipmentInventory";
import { EquipmentAssignment } from "./EquipmentAssignment";
import { GuardEquipmentSummary } from "./GuardEquipmentSummary";
import { Card, CardContent } from "@/components/ui/card";

export const EquipmentManagement = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  
  // Function to trigger refresh in child components
  const refreshData = () => {
    setRefreshTrigger(prev => prev + 1);
  };
  
  return (
    <Card>
      <CardContent className="pt-6">
        <Tabs defaultValue="inventory" className="space-y-4">
          <TabsList>
            <TabsTrigger value="inventory">Equipment Inventory</TabsTrigger>
            <TabsTrigger value="assignment">Assign Equipment</TabsTrigger>
            <TabsTrigger value="summary">Guard Equipment Summary</TabsTrigger>
          </TabsList>
          
          <TabsContent value="inventory">
            <EquipmentInventory refreshTrigger={refreshTrigger} onDataChange={refreshData} />
          </TabsContent>
          
          <TabsContent value="assignment">
            <EquipmentAssignment refreshTrigger={refreshTrigger} onDataChange={refreshData} />
          </TabsContent>
          
          <TabsContent value="summary">
            <GuardEquipmentSummary refreshTrigger={refreshTrigger} />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};
